import {getColorValue} from 'appearance'

let swalModule

const loadSwal = async () => {
    if (swalModule) return swalModule
    const [{default: Swal}, {default: withReactContent}] = await Promise.all([
        import('sweetalert2'),
        import('sweetalert2-react-content'),
    ])
    const MySwal = withReactContent(Swal)
    swalModule = {Swal, MySwal}
    return swalModule
}

const elevateSwal = (Swal) => {
    const container = Swal.getContainer?.()
    if (container) {
        container.style.zIndex = '2100'
    }
}

export const showErrorAlert = async (text, t) => {
    const {Swal, MySwal} = await loadSwal()
    MySwal.fire({
        icon: 'error',
        titleText: t('modal.modal_error_title'),
        text,
        didOpen: () => elevateSwal(Swal),
    })
}
export const showSuccessAlert = async (title, onClose) => {
    const {Swal, MySwal} = await loadSwal()
    MySwal.fire({
        position: 'center',
        icon: 'success',
        title,
        showConfirmButton: true,
        timer: 3000,
        didOpen: () => elevateSwal(Swal),
        didClose: () => onClose?.(),
    })
}

export const showConfirmAlert = async ({
    e,
    text = '',
    onConfirm,
    onCancel,
    disableSuccessAlert = true,
    t,
    title,
    confirmButtonText,
    confirmButtonColor = getColorValue('APP_PRIMARY_MAIN'),
    cancelButtonText,
    successText,
    icon = 'warning',
    iconColor = getColorValue('ERROR_BORDER'),
}) => {
    e?.stopPropagation?.()
    const {Swal, MySwal} = await loadSwal()
    MySwal.fire({
        title: title || t('modal.confirm_title'),
        text,
        icon,
        showCancelButton: true,
        confirmButtonColor,
        iconColor,
        confirmButtonText: confirmButtonText || t('modal.confirm_action'),
        cancelButtonText: cancelButtonText || t('modal.cancel'),
        reverseButtons: true,
        didOpen: () => elevateSwal(Swal),
    }).then((result) => {
        if (result.isConfirmed) {
            onConfirm?.()
            if (!disableSuccessAlert && successText) {
                MySwal.fire({
                    title: successText,
                    icon: 'success',
                    confirmButtonColor: getColorValue('APP_PRIMARY_MAIN'),
                })
            } else {
                MySwal.close()
            }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
            onCancel?.()
        }
    })
}

export const showDeleteAlert = async (
    e,
    text = '',
    onConfirm,
    onCancel,
    disableSuccessAlert,
    t
) =>
    showConfirmAlert({
        e,
        text,
        onConfirm,
        onCancel,
        disableSuccessAlert,
        t,
        confirmButtonText: t('modal.confirm_delete'),
        confirmButtonColor: getColorValue('red'),
        successText: t('modal.delete_success'),
    })

export const beforeCloseModalOrResetAlert = async ({
    text = '',
    onConfirm,
    title = '',
    confirmText,
    onCancel,
    t,
}) => {
    const {Swal, MySwal} = await loadSwal()
    MySwal.fire({
        title: title || t('modal.close_modal_title'),
        text,
        icon: 'warning',
        allowEscapeKey: false,
        showCancelButton: true,
        confirmButtonText: confirmText || t('modal.confirm_close'),
        cancelButtonText: t('modal.cancel'),
        reverseButtons: true,
        didOpen: () => elevateSwal(Swal),
    }).then((result) => {
        if (result.isConfirmed) {
            onConfirm?.()
        } else {
            return onCancel?.()
        }
    })
}
